import { useEffect } from 'react';

import { Output, SourceBase, WebSocketResponseByType, WebSocketResponseTypes } from 'types';

import { socketConnection } from '../contexts/WebSocketContext';

type EventUpdateDetails = WebSocketResponseByType<WebSocketResponseTypes.EVENT_UPDATES>;

export const useEventUpdated = (
  eventId: string,
  onUpdate: (sources?: SourceBase[], outputs?: Output[]) => void
): void => {
  useEffect(() => {
    socketConnection.on('message', (data) => {
      try {
        const {
          type,
          details: { eventId: wsEventId, sources, outputs },
        } = JSON.parse(JSON.stringify(data)) as EventUpdateDetails;
        if (type === WebSocketResponseTypes.EVENT_UPDATES && eventId === wsEventId)
          onUpdate(sources, outputs);
      } catch (err) {}
    });

    return () => {
      socketConnection.off('message');
    };
  }, []);
};
